<template>
  <div class="banner-warp">
    <div class="bannerform">
      <p class="title">免费领取</p>
      <p class="sub-title">1对1学习提升方案</p>
      <div class="tel-wrapper" @click="clickBannerTel">
        <input
          type="text"
          placeholder="请输入手机号"
          v-model.trim="bannerPhone"
          @blur="focusLeave()"
        />
      </div>
      <div class="error-msg" v-show="errorMsgShow">{{ errorMsg }}</div>
      <div
        class="button"
        @click="popupFormShow()"
        data-action-name="mas_banner_commit"
      >
        立即领取
      </div>
      <p>每日限额200人</p>
    </div>
    <popupform
      :isPopupFormShow="isPopupFormShow"
      :isNeedPhone="needPhone"
      @popupFormClose="popupFormClose"
      :isDirectSend="isDirectSend"
      :bannerPhone="bannerPhone"
    ></popupform>
  </div>
</template>

<script>
import popupform from "@/components/popupform";
import guardian, { LogType } from "@xes/dh-guardian-sdk";
import {saTrack} from '@xes/dh-sensor';

export default {
  name: "bannerform",
  data() {
    return {
      needPhone: false,
      isPopupFormShow: false,
      errorMsg: "",
      errorMsgShow: false,
      isDirectSend: false,
      bannerPhone: "",
      errorMsgShowTimer: 0,
    };
  },
  components: {
    popupform,
  },
  watch: {
    errorMsgShow() {
      if (this.errorMsgShow) {
        this.errorMsgShowTimer = setTimeout(() => {
          this.errorMsgShow = false;
        }, 2000);
      }
    },
  },
  methods: {
    clickBannerTel() {
      saTrack("CardInputPhone");
    },
    popupFormShow() {
      if (!this.bannerPhone) {
        this.errorMsgShow = true;
        this.errorMsg = "请输入手机号";
        return;
      } else if (!/^1[345789]\d{9}$/.test(this.bannerPhone)) {
        this.errorMsgShow = true;
        this.errorMsg = "请输入正确手机号";
        return;
      }
      saTrack("AppointmentInputPhone",{str_param1:"banner_立即领取"});
      this.isDirectSend = true;
      this.isPopupFormShow = true;
    },
    popupFormClose(data) {
      this.isDirectSend = false;
      this.isPopupFormShow = data;
      this.errorMsgShow = false;
      this.bannerPhone = "";
    },
    focusLeave() {
      guardian.log(
        "click",
        { action_name: "mas_banner_phone_number" },
        LogType.interaction
      );
    },
  },
};
</script>
<style scoped lang="scss">
.banner-warp {
  width: 1200px;
  height: 500px;
  margin: 0 auto;
  position: relative;
  top: -500px;
  .bannerform {
    box-sizing: border-box;
    position: absolute;
    top: 72px;
    right: 0;
    margin: 0 auto;
    padding: 51px 20px 39px;
    width: 350px;
    height: 351px;
    background: #ffffff;
    border-radius: 6px;
    .title {
      height: 26px;
      font-size: 26px;
      font-weight: 600;
      color: #e61623;
      line-height: 26px;
      text-align: center;
    }
    .sub-title {
      height: 23px;
      line-height: 23px;
      font-weight: 600;
      color: #333333;
      font-size: 20px;
      margin: 10px 0 23px;
      text-align: center;
    }
    p:last-child {
      height: 15px;
      font-size: 16px;
      letter-spacing: 1px;
      font-weight: 400;
      color: #666666;
      line-height: 15px;
      text-align: center;
    }
    .error-msg {
      width: 310px;
      position: absolute;
      margin: 0 auto;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      color: rgba(224, 39, 39, 1);
    }
    .tel-wrapper {
      width: 310px;
      height: 57px;
      border: 1px solid #e61623;
      border-radius: 29px;
      input {
        height: 55px;
        box-sizing: border-box;
        width: 283px;
        outline: 0;
        border: none;
        font-size: 14px;
        letter-spacing: 1px;
        line-height: 59px;
        border-radius: 29px;
        padding-left: 22px;
      }
    }
    .button {
      margin-top: 30px;
      margin-bottom: 24px;
      width: 310px;
      height: 50px;
      background: #df2727;
      border-radius: 25px;
      line-height: 50px;
      letter-spacing: 1px;
      text-align: center;
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
    }
    .button:hover {
      cursor: pointer;
    }
  }
}
</style>
